import request from '@/utils/request'
import requestJson from "@/utils/requestJson"

// 行情价列表
export function marketPriceGetList(data) {
  return request({
    url: '/admin/market_price/getList',
    method: 'get',
    params: data
  })
}

// 添加行情价
export function marketPriceAdd(data) {
  return requestJson({
    url: '/admin/market_price/add',
    method: 'post',
    data
  })
}

// 保存行情价（不存在新增，存在更新）
export function marketPriceSave(data) {
  return requestJson({
    url: '/admin/market_price/save',
    method: 'post',
    data
  })
}

// 更新行情价
export function marketPriceUp(data) {
  return requestJson({
    url: '/admin/market_price/up',
    method: 'post',
    data
  })
}

// 获取未添加行情价的商品列表
export function marketPriceGetUnadded(data) {
  return request({
    url: '/admin/market_price/getUnadded',
    method: 'get',
    params: data
  })
}

// 删除行情价
export function marketPriceDel(data) {
  return request({
    url: '/admin/market_price/del',
    method: 'get',
    params: data
  })
}

// 获取已有行情价的商品ID列表
export function marketPriceGetExistingItemIds() {
  return request({
    url: '/admin/market_price/getExistingItemIds',
    method: 'get'
  })
}

// 获取上次采购价
export function marketPriceGetLastPurchasePrice(data) {
  return request({
    url: '/admin/market_price/getLastPurchasePrice',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/marketPrice.js